import { Schedule, DateInput, Icon } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import { SectionTitle } from '../../../components/text';
import CourseTypeLegends from '../../../packages/parts/CourseTypeLegends';
import { SectionSchedule } from '../../../types/sectionMaintainerTypes';
import { TimeModuleType } from '../../../types/timeModuleTypes';
import { SectionScheduleGetResponse } from '../types';
import { useWeeklyScheduleCalendar } from '../hooks/useWeeklyScheduleCalendar';

const SectionShowSchedule = ({
  section,
  sectionSchedules,
  modules,
  legends,
}: {
  section: SectionScheduleGetResponse['section'];
  sectionSchedules: SectionSchedule[];
  modules: TimeModuleType[];
  legends: { id: number; name: string }[];
}) => {
  const prefix = 'sectionsMaintainer.update';
  const { t } = useTranslation();

  const {
    selectedWeek,
    nextWeek,
    previousWeek,
    selectWeek,
    schedules,
    datesWithEvents,
    days,
  } = useWeeklyScheduleCalendar(sectionSchedules, section);

  return (
    <Row>
      <Col xs={6}>
        <SectionTitle text={t(`${prefix}.showSchedule`)} />
      </Col>
      <Col xs={12}>
        {/* Navegación semanal */}
        <Row className="d-flex align-items-center mx-0 my-2">
          <span onClick={previousWeek} className="cursor-pointer">
            <Icon className="mr-4" name="chevron_left" />
          </span>
          <span onClick={nextWeek} className="cursor-pointer">
            <Icon name="chevron_right" />
          </span>
          <Col
            xs={1}
            className="fs-20 text-uppercase text-primary fw-700 mb-0 ml-4"
          >
            <Row>{selectedWeek.start.format('MMMM')}</Row>
            <Row>{selectedWeek.start.format('YYYY')}</Row>
          </Col>
          <Col xs={3}>
            <DateInput
              label={t(`${prefix}.viewCalendar`)}
              name="weekSelector"
              value={selectedWeek.selectedDay.format()}
              onChange={(date) => selectWeek(date)}
              datesWithEvents={datesWithEvents}
            />
          </Col>
        </Row>
      </Col>
      <Col xs={12} md={11} lg={10} className="mx-auto">
        <Schedule
          mobileNavigation
          days={days}
          schedules={schedules}
          modules={modules}
        />
      </Col>
      <Col xs={12} md={11} lg={9} className="pt-5 mx-auto">
        <CourseTypeLegends legends={legends} />
      </Col>
    </Row>
  );
};

export default SectionShowSchedule;
